import { ColumnOrder } from "../../../../../base/styles";
import clsx from "clsx";

export const SelectColumnOrder = ({ title, value, className, onChange }:{
    title: string,
    value?: ColumnOrder,
    className?: string,
    onChange: (value?: ColumnOrder) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as ColumnOrder;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={ColumnOrder.Order0}>0</option>
                <option value={ColumnOrder.Order1}>1</option>
                <option value={ColumnOrder.Order2}>2</option>
                <option value={ColumnOrder.Order3}>3</option>
                <option value={ColumnOrder.Order4}>4</option>
                <option value={ColumnOrder.Order5}>5</option>
            </select>
        </div>
    )
}